
import { useEffect } from "react";

export default function useScrollReveal() {
  useEffect(() => {
    // Small delay to ensure DOM is fully rendered
    const timeout = setTimeout(() => {
      const revealElements = document.querySelectorAll(".scroll-reveal");
      
      // Reveal elements immediately if they're already in viewport on mount
      revealElements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (isVisible) {
          element.classList.add("revealed");
        }
      });
      
      const revealCallback = (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      };
      
      const observer = new IntersectionObserver(revealCallback, {
        threshold: 0.05,
        rootMargin: "150px 0px 0px 0px"
      });
      
      revealElements.forEach(element => {
        observer.observe(element);
      });
      
      return () => {
        revealElements.forEach(element => {
          observer.unobserve(element);
        });
      };
    }, 100);

    return () => clearTimeout(timeout);
  }, []);
}
